<template>
    <div class="wrapper-style">
        <div class="fix-bg">
            <div class="bgview">
                <div class="gradient-cover"></div>
                <div class="wave-t"></div>
                <div class="wave-mid"></div>
                <div class="wave-bt"></div>
                <div class="fire-left"><div class="bgshow"></div></div>
                <div class="fire-right"><div class="bgshow"></div></div>
            </div>
        </div>
        <div class="page-box start-box">
            <div class="bgview start-page">
                <div class="start-event-logo"><div class="bgshow"></div></div>
                <div class="start-role-box">
                    <div class="start-people">
                        <div class="bgshow">
                            <div class="view"><div class="bg"></div></div>
                        </div>
                    </div>
                    <div class="start-role-tit"><div class="bgshow"></div></div>
                </div>
                <div class="start-event-tit"><div class="bgshow"></div></div>
                <div class="start-btn">
                    <div class="bgshow">
                        <button type="button" class="view" v-on:click="start"></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import LottieAnimation from 'lottie-web-vue'


export default {
    name:"Home",
    props: ["path"],
    data() {
        return {

        }
    },
    components:{
        LottieAnimation
    },
    methods: {
        start(){
            this.$gtag.event('click_start')
            this.$emit('switch-component', 'questionnaire')
        }
    },
    mounted: function () {
        this.$gtag.event('view_landing_page')
    },
    watch: {
    }
}
</script>
